module.exports = __webpack_public_path__ + "img/logo.817e3360.svg";